import { FeeScriptingEnum, FeeInfo } from "./types";

/**
 * Formats a fee amount to display currency with GST
 * @param amount - The fee amount
 * @returns Formatted currency string
 */
const formatFeeAmount = (amount: number): string => {
  return `$${amount.toFixed(2)}`;
};

/**
 * Generates fee text based on fee scripting type and amounts
 * @param feeInfo - Fee information containing scripting type and amounts
 * @param supplyType - Type of supply (electricity/gas)
 * @returns Fee description text
 */
export const generateFeeText = (
  feeInfo: FeeInfo,
  supplyType: string = "electricity"
): string => {
  const { feeScripting, dbFee, mpFee } = feeInfo;

  switch (feeScripting) {
    case FeeScriptingEnum.DB_FEE_ONLY:
      return `The fee from your distributor to remove the ${supplyType} supply and meter is up to ${formatFeeAmount(
        dbFee || 0
      )} incl GST. We will pass through the fee your distributor charges us on your next bill after the abolishment is completed.`;

    case FeeScriptingEnum.MP_FEE_ONLY:
      return `The fee from the metering provider to remove the electricity meter is up to ${formatFeeAmount(
        mpFee || 0
      )} incl GST. We will pass through the fee your metering provider charge us on your next bill after the abolishment is completed.`;

    case FeeScriptingEnum.DBMP_FEE:
      return `The fee from your distributor to remove the electricity supply is up to ${formatFeeAmount(
        dbFee || 0
      )} incl GST. And the fee from the metering provider to remove the electricity meter is up to ${formatFeeAmount(
        mpFee || 0
      )} incl GST. We will pass through the fee your distributor and metering provider charge us on your next bill after the abolishment is completed.`;

    case FeeScriptingEnum.QUOTE:
      return `The fees to remove the ${supplyType} supply and meter are dependent on the work that is completed by the distributor at your property. The distributor should inform you of these fees before they proceed and we will pass through these fees on your next bill after the abolishment is completed`;

    case FeeScriptingEnum.SERVICE_QUOTE:
      return `The fee from your distributor to remove the gas meter is up to ${formatFeeAmount(
        dbFee || 0
      )} incl GST. And the fees to remove the gas supply are dependent on the works that is completed by the distributor at your property. The distributor should inform you of these fees before they proceed, and we will pass through the fees on your next bill after the abolishment.`;

    case FeeScriptingEnum.NO_FEE:
      return "N/A";

    default:
      return "Fee information not available.";
  }
};
